import Mutations from '../../odata/mutations';

export default {
  ...new Mutations('webCategory1'),
  ...new Mutations('webCategory2'),
  ...new Mutations('webCategory3'),
  ...new Mutations('webCategory4'),
};
